import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/crossplatform.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/datacollection.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/datasecurity.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/globalreach.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/qualitycontrol.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/qualitymanagement.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/realtimedata.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/sampling.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/survey.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datacollection/transparency.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/DataCollectionMobileCarousel/index.tsx");
